import React from 'react';
import Header from './pages/Header';
import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import Home from './pages/Home';
import Pageabout from './pages/Pageabout';
import Pageclub from './pages/Pageclub';
import Pagework from './pages/Pagework';
import Pagecontact from './pages/Pagecontact';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path = "/" element = {<Header />}>
          <Route index element={<Home />} />
          <Route path = "about" element ={<Pageabout />} />
          <Route path = "club" element ={<Pageclub />} />
          <Route path = "work" element ={<Pagework />} />
          <Route path = "contact" element ={<Pagecontact />} />
        </Route>
      </Routes>
    </HashRouter>
  )
}


